/* eslint-disable import/no-anonymous-default-export */
import { makeAutoObservable } from "mobx";
import { SocketType } from "../types/storeType";

class SocketState {
    username: string = '';
    socket: SocketType = null;
    sessionId: string = '';

    constructor() {
        makeAutoObservable(this)
    }

    setSocket(socket: SocketType) {
        this.socket = socket;
    }

    setSessionId(id: string) {
        this.sessionId = id;
    }

    setUsername(username: string) {
        this.username = username;
    }

}

export default new SocketState()